import i18next from 'i18next';
import { useTranslation } from 'react-i18next';
import LanguageSwitcher from 'components/LanguageSwitcher';
import 'assets/css/components/Header.scss';

const Header = (): JSX.Element => {
  const { t } = useTranslation();

  return (
    <header className='page-header'>
      <div className='page-header__inner'>

        <h1 className='page-header__title'>
          { t('title') }
        </h1>

        <div className='page-header__actions'>
          <LanguageSwitcher
            currentLanguage={ i18next.resolvedLanguage }
            options={ [
              "nl", "en", "fr"
            ] }
          />
        </div>

      </div>
    </header>
  );
}

export default Header;
